module.exports = __webpack_public_path__ + "img/icon-ensign.757bc95f.png";